import React from 'react';
import { GithubOutlined, TwitterOutlined, WeiboOutlined, TikTokOutlined } from '@ant-design/icons';
import './Footer.less';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="app-footer">
      <div className="footer-content">
        <div className="footer-columns">
          <div className="footer-column">
            <h3>关于我们</h3>
            <p><a href="/about">关于我们</a></p>
            <p><a href="/about/introduction">学校简介</a></p>
            <p><a href="/about/history">发展历程</a></p>
            <p><a href="/about/contact">联系方式</a></p>
          </div>
          <div className="footer-column">
            <h3>教学科研</h3>
            <p><a href="/academics">教学科研</a></p>
            <p><a href="/academics/departments">院系设置</a></p>
            <p><a href="/academics/majors">专业设置</a></p>
            <p><a href="/academics/research">科研成果</a></p>
          </div>
          <div className="footer-column">
            <h3>联系我们</h3>
            <p>邮箱：contact@example.com</p>
            <p>电话：123-456-7890</p>
          </div>
          <div className="footer-column">
            <h3>社交媒体</h3>
            <div className="social-icons">
              <a href="#" className="social-icon"><GithubOutlined /></a>
              <a href="#" className="social-icon"><TwitterOutlined /></a>
              <a href="#" className="social-icon"><WeiboOutlined /></a>
              <a href="#" className="social-icon"><TikTokOutlined /></a>
            </div>
          </div>
        </div>
        <div className="copyright-section">
          <p className="copyright-text">
            版权©️羊小羊 {currentYear} 保留所有权利.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;